/**
 * Root component — sets up client-side routing.
 *
 *   /              → Landing page with game list
 *   /play/:slug    → Game streaming player
 *   /privacy       → Privacy Notice
 */

import { BrowserRouter, Routes, Route, useParams, Navigate } from "react-router";
import { LandingPage } from "./components/LandingPage";
import { GamePlayer } from "./components/GamePlayer";
import { PrivacyNotice } from "./components/PrivacyNotice";
import { GAMES } from "@shared/games";

function PlayRoute() {
  const { slug } = useParams<{ slug: string }>();
  const game = slug ? GAMES[slug] : undefined;

  if (!game) return <Navigate to="/" replace />;

  return <GamePlayer slug={slug!} game={game} />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/play/:slug" element={<PlayRoute />} />
        <Route path="/privacy" element={<PrivacyNotice />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
